import { render } from "./authCode.vue?vue&type=template&id=2b372948&scoped=true"
import script from "./authCode.vue?vue&type=script&lang=js"
export * from "./authCode.vue?vue&type=script&lang=js"

import "./authCode.vue?vue&type=style&index=0&id=2b372948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b372948"]])

export default __exports__